import { render, staticRenderFns } from "./PageListTile.vue?vue&type=template&id=1b5d8185&"
import script from "./PageListTile.vue?vue&type=script&lang=ts&"
export * from "./PageListTile.vue?vue&type=script&lang=ts&"
import style0 from "./PageListTile.vue?vue&type=style&index=0&id=1b5d8185&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports